import { render, staticRenderFns } from "./AscFilterLegend.vue?vue&type=template&id=0f245985&"
import script from "./AscFilterLegend.vue?vue&type=script&lang=js&"
export * from "./AscFilterLegend.vue?vue&type=script&lang=js&"
import style0 from "./AscFilterLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
